<div class="ion-padding">
  <ion-card>
    <ion-card-header>
      <ion-card-title>Tömeges stornózás</ion-card-title>
      <ion-card-subtitle>
        Számlatömb és sorszám-intervallum megadásával egyszerre több számlát küldhet be stornóra a NAV felé.
        A rendszer minden érintett számláról automatikusan kiállítja a (mínuszos) storno számlát.
      </ion-card-subtitle>
    </ion-card-header>

    <ion-card-content>
      <ion-progress-bar type="indeterminate" *ngIf="loading"></ion-progress-bar>

      <ion-item>
        <ion-label position="stacked">Számlatömb</ion-label>
        <ion-select [(ngModel)]="selectedTomb" interface="popover" placeholder="Válasszon számlatömböt">
          <ion-select-option *ngFor="let t of tombok" [value]="t.id">
            {{ t.nev }} ({{ t.elotag }})
          </ion-select-option>
        </ion-select>
      </ion-item>

      <ion-grid>
        <ion-row>
          <ion-col size="6">
            <ion-item>
              <ion-label position="stacked">Sorszámtól</ion-label>
              <ion-input type="number" [(ngModel)]="from" placeholder="pl. 100"></ion-input>
            </ion-item>
          </ion-col>
          <ion-col size="6">
            <ion-item>
              <ion-label position="stacked">Sorszámig</ion-label>
              <ion-input type="number" [(ngModel)]="to" placeholder="pl. 150"></ion-input>
            </ion-item>
          </ion-col>
        </ion-row>
      </ion-grid>

      <ion-item>
        <ion-checkbox slot="start" [(ngModel)]="reverseEgyenleg"></ion-checkbox>
        <ion-label class="ion-text-wrap">
          Egyenleg visszaírása
          <p style="font-size:12px; color:#888">
            Bejelölve: jóváírás kerül az egyenlegre, és az étkezésből generált számláknál az alkalmak
            visszaállnak fizetetlenre (újra kiállítható a számla). Üresen: csak a stornózás történik meg,
            az egyenleg nem változik.
          </p>
        </ion-label>
      </ion-item>

      <div style="display:flex; gap:8px; margin-top:16px; flex-wrap:wrap">
        <ion-button color="danger" id="storno-koteg-confirm" [disabled]="!ervenyes || loading">
          <ion-icon slot="start" name="trash-outline"></ion-icon>
          Tömeges stornózás
        </ion-button>
        <ion-button fill="clear" color="medium" (click)="loadTombok()" [disabled]="loading">
          Tömbök újratöltése
        </ion-button>
      </div>

      <ion-alert
        trigger="storno-koteg-confirm"
        header="Biztosan stornózzuk?"
        message="A kiválasztott intervallumban lévő összes számlát stornózza és beküldi a NAV felé. A művelet nem vonható vissza."
        [buttons]="[
          { text: 'Mégse', role: 'cancel' },
          { text: 'Stornózás', role: 'confirm' }
        ]"
        (didDismiss)="stornozas($event)"
      ></ion-alert>

      <ion-note color="medium" style="display:block; margin-top:12px; font-size:12px">
        Csak a még nem stornózott, valós számlák kerülnek feldolgozásra (a már meglévő storno bizonylatok kimaradnak).
        Ha egy NAV beküldés nem sikerül, a storno bizonylat akkor is elkészül, és a rendszer 5 percenként
        automatikusan újrapróbálja a beküldést.
      </ion-note>
    </ion-card-content>
  </ion-card>

  <ion-card *ngIf="osszesito">
    <ion-card-header>
      <ion-card-title>Eredmény</ion-card-title>
      <ion-card-subtitle>
        Összesen: {{ osszesito.osszesen }} •
        Stornózva: {{ osszesito.sikeres }} •
        NAV beküldve: {{ osszesito.navSikeres }}
      </ion-card-subtitle>
    </ion-card-header>
    <ion-card-content>
      <table class="storno-tabla">
        <thead>
          <tr>
            <th>Sorszám</th>
            <th>Eredeti számla</th>
            <th>Storno számla</th>
            <th>Állapot</th>
            <th>Megjegyzés</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let r of results">
            <td>{{ r.sorszam }}</td>
            <td>{{ r.szamlaszam }}</td>
            <td>{{ r.stornoSzamlaszam }}</td>
            <td>
              <ion-badge *ngIf="r.ok && r.navbekuldve" color="success">NAV-ba beküldve</ion-badge>
              <ion-badge *ngIf="r.ok && !r.navbekuldve" color="warning">Storno kész, NAV függőben</ion-badge>
              <ion-badge *ngIf="!r.ok" color="danger">Sikertelen</ion-badge>
            </td>
            <td class="megjegyzes">{{ r.error || navHibaSzoveg(r) }}</td>
          </tr>
        </tbody>
      </table>
    </ion-card-content>
  </ion-card>
</div>
